export interface MobileRuntimeSnapshot {
  isMobile: boolean;
  orientation: "landscape" | "portrait";
  viewportWidth: number;
  viewportHeight: number;
}

const MOBILE_LANDSCAPE_CAMERA_ZOOM = 0.86;
const MOBILE_PORTRAIT_CAMERA_ZOOM = 0.78;

export function detectMobileRuntime(win: Window = window): boolean {
  const nav = win.navigator;
  const coarsePointer = win.matchMedia?.("(pointer: coarse)").matches ?? false;
  const compactViewport = Math.min(win.innerWidth, win.innerHeight) <= 640;
  const userAgent = nav.userAgent.toLowerCase();
  const mobileUserAgent = /android|iphone|ipad|ipod|mobile|windows phone/.test(
    userAgent,
  );
  return coarsePointer || (compactViewport && mobileUserAgent);
}

export function readMobileRuntimeSnapshot(
  win: Window = window,
): MobileRuntimeSnapshot {
  const viewport = win.visualViewport;
  const viewportWidth = Math.max(
    1,
    Math.round(viewport?.width ?? win.innerWidth),
  );
  const viewportHeight = Math.max(
    1,
    Math.round(viewport?.height ?? win.innerHeight),
  );
  return {
    isMobile: detectMobileRuntime(win),
    orientation: viewportWidth >= viewportHeight ? "landscape" : "portrait",
    viewportWidth,
    viewportHeight,
  };
}

export function applyMobileRuntimeClasses(
  body: HTMLElement,
  snapshot: MobileRuntimeSnapshot,
): void {
  body.classList.toggle("is-mobile-runtime", snapshot.isMobile);
  body.classList.toggle(
    "is-mobile-landscape",
    snapshot.isMobile && snapshot.orientation === "landscape",
  );
  body.classList.toggle(
    "is-mobile-portrait",
    snapshot.isMobile && snapshot.orientation === "portrait",
  );
}

export function getRuntimeCameraZoom(snapshot: MobileRuntimeSnapshot): number {
  if (!snapshot.isMobile) {
    return 1;
  }
  return snapshot.orientation === "landscape"
    ? MOBILE_LANDSCAPE_CAMERA_ZOOM
    : MOBILE_PORTRAIT_CAMERA_ZOOM;
}
